import { MutableRefObject } from 'react';

import { FIELD_ID, NODE_ID, type TUniqueIdAttribute, uniqueIdPasteRule } from '../../extensions/CustomUniqueId';
import { withTransportedOptions } from '../../extensions/DropdownOptionsTransport';
import type { TTransformFragment } from '../../extensions/PasteRule';
import { carryDropdownOptions } from './dropdownFieldUtils';

// Copied fields are new fields, whether pasted, dropped as a copy or duplicated; form fields bring their options.
const getCopyRules = (
  optionsRef: MutableRefObject<Record<string, string[]>>,
  usesFormFields: boolean
): { idAttributes: TUniqueIdAttribute[]; copyFields: TTransformFragment } => {
  const idAttributes: TUniqueIdAttribute[] = [{ ...FIELD_ID, onRegenerate: carryDropdownOptions(optionsRef) }, NODE_ID];
  const renewIds = uniqueIdPasteRule(idAttributes);
  return { idAttributes, copyFields: usesFormFields ? withTransportedOptions(renewIds, optionsRef) : renewIds };
};

export default getCopyRules;
